var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"chart-wrapper"},[_c('Chart')],1),_c('div',{staticClass:"card-wrapper"},[_c('Card',{attrs:{"data":_vm.cardData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }